export default __webpack_public_path__ + "static/media/Taylor.2268d1d2.png";